import { useEffect } from "react";
import { Link } from "react-router-dom";
import { HardHat } from "lucide-react";
import { APP_NAME } from "@crewledger/shared/constants";
import { useAuth } from "@/features/auth/auth-provider";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export function NotInvitedPage() {
  const { logout } = useAuth();

  useEffect(() => {
    document.title = `Private beta — ${APP_NAME}`;
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/30 p-6">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto mb-2 flex h-12 w-12 items-center justify-center rounded-lg bg-primary text-primary-foreground">
            <HardHat className="h-6 w-6" />
          </div>
          <CardTitle>Private beta</CardTitle>
          <CardDescription>
            Werkio is currently in private beta. This email is not on the beta allowlist yet.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <Link to="/request-access" className="block">
            <Button className="w-full">Request Access</Button>
          </Link>
          <Button className="w-full" variant="outline" onClick={() => void logout()}>
            Sign out
          </Button>
          <p className="text-center text-sm text-muted-foreground">
            <Link to="/demo" className="font-medium text-orange-construction hover:underline">
              Try the demo
            </Link>
            {" · "}
            <Link to="/" className="font-medium hover:underline">
              Home
            </Link>
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
